import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from '../firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    representativeBooking: false,
    results: [
      {
        id: 'gender',
        selfTitle: 'You are not female',
        representativeTitle: 'She is not female',
        description: "'Basic Bekam' therapy is currently offered to female clients only."
      },
      {
        id: 'menstruation',
        selfTitle: 'You are menstruating',
        representativeTitle: 'She is menstruating',
        description: 'Women who are menstruating are discouraged to undergo any wet bekam therapy.'
      },
      {
        id: 'bloodClottingMedication',
        selfTitle: 'You are on anti-blood clotting medication',
        representativeTitle: 'She is on anti-blood clotting medication',
        description: 'Individuals who are on blood thinning medications such as aspirin and warfarin are STRICTLY prohibited from undergoing any wet bekam therapy without Doctor’s consultation.'
      },
      {
        id: 'pregnancy',
        selfTitle: 'You are pregnant. Congrats!',
        representativeTitle: 'She is pregnant. Congrats!',
        description: 'For the baby’s safety, pregnant women are discouraged from undergoing any wet bekam therapy.'
      },
      {
        id: 'diabetes',
        selfTitle: 'You have high blood sugar',
        representativeTitle: 'She has high blood sugar',
        description: 'Individuals with uncontrolled blood sugar are discouraged to undergo any wet bekam therapy without the close monitoring of a qualified healthcare practitioners due to the higher risk of wound infection.'
      },
      {
        id: 'hypertension',
        selfTitle: 'You have uncontrolled blood pressure',
        representativeTitle: 'She has uncontrolled blood pressure',
        description: 'For safety precautions, individuals with uncontrolled blood pressure are discouraged to undergo any wet bekam therapy.'
      }
    ],
    checkedResults: [],
    diabetesConsultation: null,
    hypertensionConsultation: null
  },
  mutations: {
    setCheckedResults(state, payload) {
      state.diabetesConsultation = null
      state.hypertensionConsultation = null
      const consultationTypes = payload.criteriaPassed.filter(criteria => criteria.includes('consult'))
      if (consultationTypes && consultationTypes.length > 0) {
        if (consultationTypes.includes('consult_diabetes')) state.diabetesConsultation = true
        if (consultationTypes.includes('consult_hypertension')) state.hypertensionConsultation = true
      }

      const filteredResults = state.results.filter(result => !payload.criteriaPassed.includes(result.id))
      state.checkedResults = filteredResults
      state.representativeBooking = payload.representativeBooking
    }
  },
  actions: {
    async login({ commit }, form) {
      commit
      let error = { message: '', isError: false }
      await auth.signInWithEmailAndPassword(form.email, form.password).catch(err => {
        error = { message: err.message, isError: true }
      })

      if (error.isError) return error
    },
    async logout({ commit }) {
      commit
      await auth.signOut()
    }
  }
})
